/**
 * Cronometro de despacho prioritario no carrinho lateral.
 *
 * O prazo e real: o fulfillment da ZEPH expede com prioridade os pedidos
 * fechados dentro de 1 hora. Por isso o relogio:
 * - comeca quando o primeiro item entra no carrinho, e nao a cada visita;
 * - sobrevive a recarregar a pagina (localStorage);
 * - some ao chegar a zero, em vez de reiniciar (reiniciar sozinho seria
 *   urgencia falsa);
 * - depois de vencido, so volta com uma acao real do cliente: um item novo
 *   no carrinho abre um prazo novo de 1 hora (antes o relogio so voltava
 *   se o carrinho fosse esvaziado, e quem deixava itens la nunca mais o via);
 * - zera quando o carrinho esvazia.
 *
 * O elemento carrega data-skip-node-update: o Horizon re-renderiza o drawer
 * a cada mudanca no carrinho e, sem isso, voltaria o texto para o valor do
 * servidor a cada clique.
 */

const STORAGE_KEY = 'zeph-cart-dispatch-deadline';
const COUNT_KEY = 'zeph-cart-dispatch-count';

function read(key) {
  try {
    return Number(localStorage.getItem(key)) || 0;
  } catch {
    return 0;
  }
}

function write(key, value) {
  try {
    if (value) localStorage.setItem(key, String(value));
    else localStorage.removeItem(key);
  } catch {
    /* navegacao privada sem storage: o relogio vale so para esta pagina */
  }
}

const readDeadline = () => read(STORAGE_KEY);
const writeDeadline = (value) => write(STORAGE_KEY, value);

/* Quantidade de itens do contador do header, que o Horizon atualiza em
   qualquer adicao (PDP, sticky, Kaching, quick add, cross-sell). */
function cartCount() {
  const bubble = document.querySelector('[ref="cartBubbleCount"]');
  return bubble ? parseInt(bubble.textContent || '0', 10) || 0 : null;
}

let memoryDeadline = 0;
let memoryCount = 0;

function tick() {
  // Sem drawer na pagina (ex.: /cart), nao ha como saber o estado: nada muda.
  const drawer = document.querySelector('#cart-drawer .cart-drawer__inner');
  if (!drawer) return;

  // O Horizon marca o drawer vazio com esta classe e a atualiza a cada
  // mudanca; o proximo item comeca um prazo novo.
  if (drawer.classList.contains('cart-drawer--empty')) {
    writeDeadline(0);
    write(COUNT_KEY, 0);
    memoryDeadline = 0;
    memoryCount = 0;
    return;
  }

  const timer = drawer.querySelector('[data-zeph-cart-timer]');
  if (!timer) return;

  const count = cartCount();
  const storedCount = read(COUNT_KEY) || memoryCount;
  const windowMs = Number(timer.dataset.minutes || 60) * 60000;

  let deadline = readDeadline() || memoryDeadline;
  const expired = deadline && deadline <= Date.now();

  // Prazo novo: primeiro item, ou item adicionado depois do prazo vencer.
  if (!deadline || (expired && count !== null && count > storedCount)) {
    deadline = Date.now() + windowMs;
    writeDeadline(deadline);
  }
  memoryDeadline = deadline;

  // Guarda a quantidade atual; se o cliente remover itens, a referencia
  // desce junto, e so uma adicao posterior conta como item novo.
  if (count !== null) {
    write(COUNT_KEY, count);
    memoryCount = count;
  }

  const remaining = deadline - Date.now();
  if (remaining <= 0) {
    timer.hidden = true;
    return;
  }

  const minutes = Math.floor(remaining / 60000);
  const seconds = Math.floor((remaining % 60000) / 1000);
  const clock = timer.querySelector('[data-zeph-cart-timer-clock]');
  if (clock) clock.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  timer.hidden = false;
}

tick();
setInterval(tick, 1000);
